import { useState } from "react";
import { motion } from "framer-motion";
import { Check, Copy, Share2, Trophy } from "lucide-react";

export const ReferralCard = ({ name, status }) => {
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/?ref=${status?.referral_code ?? ""}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); } catch { /* clipboard blocked */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  const share = () => navigator.share?.({ title: "Drive with Marketgetr", text: "Marketgetr is recruiting drivers before launch. Get on the list:", url: link }).catch(() => {});

  return (
    <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} className="py-4" data-testid="waitlist-success-banner">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#2F7FF0]">You're on the driver list</p>
      <h3 className="font-display text-3xl sm:text-4xl font-extrabold text-[#13296B] mt-2">Nice{name ? `, ${name}` : ""}. Now move up.</h3>
      <div className="mt-6 grid grid-cols-2 gap-3">
        <div className="rounded-2xl bg-[#13296B] text-white p-5" data-testid="referral-position">
          <Trophy className="h-5 w-5 text-[#2F7FF0]" />
          <p className="font-display text-4xl font-extrabold mt-2">#{status?.position ?? "–"}</p>
          <p className="text-xs text-slate-300">your spot in line</p>
        </div>
        <div className="rounded-2xl bg-[#F0F5FD] p-5" data-testid="referral-count">
          <Share2 className="h-5 w-5 text-[#2F7FF0]" />
          <p className="font-display text-4xl font-extrabold text-[#13296B] mt-2">{status?.referrals ?? 0}</p>
          <p className="text-xs text-slate-600">drivers you've invited</p>
        </div>
      </div>
      <p className="mt-6 text-sm text-slate-600">Share your personal link with other drivers. Every driver who signs up with it moves you up the list, and drivers at the top get invited first.</p>
      <div className="mt-3 flex flex-col sm:flex-row gap-2">
        <input readOnly value={link} onFocus={(e) => e.target.select()} data-testid="referral-link-input" className="flex-1 min-w-0 rounded-xl border-2 border-slate-200 bg-[#F7F9FC] px-4 py-3 font-mono text-sm text-[#13296B]" />
        <button type="button" onClick={copy} data-testid="referral-copy-btn" className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#2F7FF0] text-white font-bold px-5 py-3 hover:bg-[#13296B] transition-colors duration-300">
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} {copied ? "Copied" : "Copy link"}
        </button>
        {typeof navigator !== "undefined" && navigator.share && (
          <button type="button" onClick={share} data-testid="referral-share-btn" className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-[#13296B]/15 text-[#13296B] font-bold px-5 py-3">Share</button>
        )}
      </div>
      <p className="mt-4 text-xs text-slate-500">Save this link. You can open <a href={`/?status=${status?.referral_code ?? ""}`} className="underline" data-testid="referral-status-link">your status page</a> anytime to check your spot.</p>
    </motion.div>
  );
};
